import unescapedText from 'I18n/utils/unescapedText';
// this is a function so unescapedText is not called before it can be used
const buildBaseFilterConfig = () => ({
  ProductType: {
    dataType: 'STRING',
    field: 'PRODUCT_TYPE',
    label: unescapedText('marketplaceStorefront.filters.universal.productType.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.universal.productType.placeholder'),
    options: [{
      text: unescapedText('marketplaceStorefront.filters.universal.productType.APP'),
      value: 'APP'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.productType.AGENT'),
      value: 'AGENT'
    }]
  },
  PortalInstallable: {
    dataType: 'BOOLEAN',
    field: 'PORTAL_INSTALLABLE',
    allowedAppContext: 'app',
    label: unescapedText('marketplaceStorefront.filters.universal.compatiblePlan.label')
  },
  WorksWithBreeze: {
    dataType: 'BOOLEAN',
    field: 'WORKS_WITH_BREEZE',
    label: unescapedText('marketplaceStorefront.filters.universal.breeze.label')
  },
  Installed: {
    dataType: 'BOOLEAN',
    field: 'INSTALLED',
    allowedAppContext: 'app',
    label: unescapedText('marketplaceStorefront.filters.universal.installed.label'),
    defaultValue: 'all',
    options: [{
      text: unescapedText('marketplaceStorefront.filters.universal.installed.all'),
      value: 'all'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.installed.installed'),
      value: 'true'
    }, {
      text: unescapedText('marketplaceStorefront.filters.universal.installed.notInstalled'),
      value: 'false'
    }]
  },
  PricingPlan: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'PRICING_PLAN',
    label: unescapedText('marketplaceStorefront.filters.app.pricingPlan.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.pricingPlan.placeholder')
  },
  HubspotFeatures: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'HUBSPOT_FEATURES',
    label: unescapedText('marketplaceStorefront.filters.app.hubspotFeatures.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.hubspotFeatures.placeholder')
  },
  Certified: {
    productType: 'APP',
    dataType: 'BOOLEAN',
    field: 'CERTIFIED',
    label: unescapedText('marketplaceStorefront.filters.app.certified.label')
  },
  SyncDirection: {
    productType: 'APP',
    dataType: 'STRING',
    defaultValue: 'all',
    field: 'SYNC_DIRECTION',
    label: unescapedText('marketplaceStorefront.filters.app.syncDirection.label')
  },
  AppLanguages: {
    productType: 'APP',
    dataType: 'STRING',
    isLanguage: true,
    field: 'APP_LANGUAGES',
    label: unescapedText('marketplaceStorefront.filters.app.appLanguages.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.appLanguages.placeholder')
  },
  SupportLanguages: {
    productType: 'APP',
    dataType: 'STRING',
    isLanguage: true,
    field: 'SUPPORT_LANGUAGES',
    label: unescapedText('marketplaceStorefront.filters.app.supportLanguages.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.supportLanguages.placeholder')
  },
  Category: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'CATEGORY',
    label: unescapedText('marketplaceStorefront.filters.app.category.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.category.placeholder')
  },
  ToolIntegrations: {
    productType: 'APP',
    dataType: 'STRING',
    field: 'TOOL_INTEGRATIONS',
    label: unescapedText('marketplaceStorefront.filters.app.toolIntegrations.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.toolIntegrations.placeholder')
  },
  BuiltByHubspot: {
    productType: 'APP',
    dataType: 'BOOLEAN',
    field: 'BUILT_BY_HUBSPOT',
    label: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.label'),
    defaultValue: 'all',
    options: [{
      text: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.all'),
      value: 'all'
    }, {
      text: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.hubspot'),
      value: 'true'
    }, {
      text: unescapedText('marketplaceStorefront.filters.app.builtByHubspot.partners'),
      value: 'false'
    }]
  },
  AgentType: {
    productType: 'AGENT',
    dataType: 'STRING',
    field: 'AGENT_TYPE',
    label: unescapedText('marketplaceStorefront.filters.agent.agentType.label'),
    defaultValue: 'all',
    options: [{
      text: unescapedText('marketplaceStorefront.filters.agent.agentType.all'),
      value: 'all'
    }, {
      text: unescapedText('marketplaceStorefront.filters.agent.agentType.agents'),
      value: 'STUDIO'
    }, {
      text: unescapedText('marketplaceStorefront.filters.agent.agentType.assistants'),
      value: 'ASSISTANT'
    }]
  },
  AgentTeam: {
    productType: 'AGENT',
    dataType: 'STRING',
    field: 'AGENT_TEAM',
    label: unescapedText('marketplaceStorefront.filters.agent.agentTeam.label'),
    placeholder: unescapedText('marketplaceStorefront.filters.agent.agentTeam.placeholder'),
    options: [{
      slug: 'marketing',
      text: unescapedText('marketplaceStorefront.filters.agent.agentTeam.MARKETING'),
      value: 'MARKETING'
    }, {
      slug: 'sales',
      text: unescapedText('marketplaceStorefront.filters.agent.agentTeam.SALES'),
      value: 'SALES'
    }, {
      slug: 'service',
      text: unescapedText('marketplaceStorefront.filters.agent.agentTeam.SERVICE'),
      value: 'SERVICE'
    }]
  }
});
let baseFilterConfig;
export function getBaseFilterConfig() {
  if (!baseFilterConfig) baseFilterConfig = buildBaseFilterConfig();
  return baseFilterConfig;
}